import { render, staticRenderFns } from "./jabatan.vue?vue&type=template&id=24483f0d"
import script from "./jabatan.vue?vue&type=script&lang=js"
export * from "./jabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports